/**
 * Filter view store for Projects page
 */

import { createFilterViewStore } from '@/stores/filterViewUtils/createFilterViewStore';

export const useProjectsFilterViewStore = createFilterViewStore(
  'ProjectPortfolioOverview',
  false, // Filter panel closed by default
);
